import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimeout } from 'usehooks-ts';
import Toast from '@ingka/toast';
import { ToastMessage } from '@pcmp/react-providers';
import { DEFAULT_TOAST_DURATION_MS } from '@/lib/constants';

export const ToastItem: FC<{
  item: ToastMessage;
  onDismiss: (item: ToastMessage) => void;
}> = ({ item, onDismiss }) => {
  const { t } = useTranslation();
  const [toastVisible, setToastVisible] = useState(true);
  const { message } = item;
  const hasCustomTimeout = Object.prototype.hasOwnProperty.call(
    item,
    'timeout'
  );
  const timeout = hasCustomTimeout ? item.timeout : DEFAULT_TOAST_DURATION_MS;
  const autoDismissDelay = timeout ?? null;

  const handleDismiss = async () => {
    setToastVisible(false);
    await new Promise((res) => setTimeout(res, 1000));
    onDismiss(item);
  };

  useTimeout(handleDismiss, autoDismissDelay);

  return (
    <Toast
      text={message}
      data-testid="toastItem"
      isOpen={toastVisible}
      onCloseRequest={handleDismiss}
      ariaLabelCloseBtn={t('aria.dismissNotification')}
      style={{ zIndex: 1500 }}
    />
  );
};
